import { paginationMap } from "./pagination";
import { procedureMap } from "./procedure";

export const paginatedProceduresMap: GenericObject = {
	results: procedureMap,
	...paginationMap,
};
